import "./ContentPopoverComponent.css";

const ContentPopoverComponent = ({ className, contentTitle, contentValue }) => (
  <div className={`content-popover ${className}`}>
    <p className='content-popover-title'>{contentTitle}</p>

    {contentValue && <p className='content-popover-value'>{contentValue}</p>}
  </div>
);

export default ContentPopoverComponent;
